'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _emptyFunction = require('react-utils/emptyFunction');

var _emptyFunction2 = _interopRequireDefault(_emptyFunction);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _PlacementConstants = require('../tooltip/PlacementConstants');

var _Functions = require('../core/Functions');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _UILink = require('../link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UITooltip = require('../tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _iconName = require('../utils/propTypes/iconName');

var _theme = require('HubStyleTokens/theme');

var _times = require('HubStyleTokens/times');

var _sizes = require('HubStyleTokens/sizes');

var _Styles = require('../utils/Styles');

var _tabUtils = require('./utils/tabUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TabIndicator = _styledComponents2.default.span.withConfig({
  displayName: 'UITab__TabIndicator'
})(['', ';background-color:currentColor;border-radius:24px;bottom:', ';height:', ';left:0;opacity:', ';position:absolute;width:100%;z-index:', ';'], (0, _Styles.setUiTransition)(), (0, _Styles.toPx)(parseInt(_sizes.TAB_INDICATOR_HEIGHT, 10) / 2 * -1), _sizes.TAB_INDICATOR_HEIGHT, function (_ref) {
  var tabIsActive = _ref.tabIsActive;
  return tabIsActive ? '1 !important' : '0';
}, function (_ref2) {
  var tabIsActive = _ref2.tabIsActive;
  return tabIsActive ? _sizes.MERCURY_LAYER : null;
});

var TabIcon = (0, _styledComponents2.default)(function (props) {
  var __tabIsActive = props.tabIsActive,
      rest = _objectWithoutProperties(props, ['tabIsActive']);

  return _react2.default.createElement(_UIIcon2.default, rest);
}).withConfig({
  displayName: 'UITab__TabIcon'
})(['&&&&{color:', ';}'], function (_ref3) {
  var tabIsActive = _ref3.tabIsActive;
  return tabIsActive ? 'currentColor' : null;
});
TabIcon.displayName = 'StyledTabIcon';

var handleFontFamily = function handleFontFamily(isActive) {
  return isActive ? (0, _styledComponents.css)(['', ';&:hover{', ';}'], _Styles.FONT_FAMILIES.medium, _Styles.FONT_FAMILIES.medium) : _Styles.FONT_FAMILIES.default;
};

var handleHoverColor = function handleHoverColor(isActive) {
  return !isActive ? (0, _styledComponents.css)(['&:hover{color:', ';}'], _theme.TABS_FOREGROUND_FOCUS_COLOR) : null;
};

var handleDisabledOnlyStyles = function handleDisabledOnlyStyles(isDisabled) {
  return isDisabled ? (0, _styledComponents.css)(['cursor:not-allowed;', '{color:', ';}'], TabIcon, _theme.TABS_DISABLED_COLOR) : null;
};

var handleContainedStyles = function handleContainedStyles(use, active) {
  return (0, _tabUtils.isContained)(use) ? (0, _styledComponents.css)(['transition:background-color ', ' cubic-bezier(0.25,0.1,0.25,1);background-color:', ';border-left:1px solid ', ';&:first-child{border-left:0;border-top-left-radius:inherit;}&:last-of-type{border-top-right-radius:inherit;}', '{display:none;}', ';'], _times.TABS_ACTIVATE_TRANSITION_TIMING, active ? _theme.TABS_ENCLOSED_SELECTED_BACKGROUND_COLOR : _theme.TABS_ENCLOSED_BACKGROUND_COLOR, _theme.TABS_BORDER_COLOR, TabIndicator, active ? (0, _styledComponents.css)(['border-bottom-color:', ';&::after{background:', ' !important;bottom:-1px;content:\' \';height:1px;left:0;position:absolute;width:100%;}'], _theme.TABS_ENCLOSED_SELECTED_BACKGROUND_COLOR, _theme.TABS_ENCLOSED_SELECTED_BACKGROUND_COLOR) : null) : null;
};

var StyledUITab = (0, _styledComponents2.default)(function (props) {
  var __active = props.active,
      __fill = props.fill,
      __use = props.use,
      rest = _objectWithoutProperties(props, ['active', 'fill', 'use']);

  return _react2.default.createElement(_UILink2.default, _extends({ use: 'unstyled' }, rest));
}).withConfig({
  displayName: 'UITab__StyledUITab'
})(['&&{', ';', ';', ';', ';color:', ';position:relative;transition-property:', ';white-space:nowrap;&:focus{text-decoration:none;z-index:', ';}', ';', ';', ';', ';&.sr-only-focusable{align-items:center;display:inline-flex;}}'], (0, _Styles.setFontSmoothing)('auto'), function (_ref4) {
  var active = _ref4.active;
  return handleFontFamily(active);
}, (0, _Styles.setFontSize)(_sizes.TAB_FONT_SIZE), (0, _Styles.setInputMetrics)(_sizes.TAB_PADDING_Y, _sizes.TAB_PADDING_X, _sizes.TAB_PADDING_X, _sizes.TAB_PADDING_Y, false), function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? _theme.TABS_DISABLED_COLOR + ' !important' : _theme.TABS_FOREGROUND_COLOR;
}, function (_ref6) {
  var use = _ref6.use;
  return (0, _tabUtils.isContained)(use) ? 'background-color, color' : 'color';
}, _sizes.MERCURY_LAYER, function (_ref7) {
  var active = _ref7.active;
  return handleHoverColor(active);
}, function (_ref8) {
  var disabled = _ref8.disabled;
  return handleDisabledOnlyStyles(disabled);
}, function (_ref9) {
  var fill = _ref9.fill;
  return fill ? (0, _styledComponents.css)(['text-align:center;width:100%;']) : null;
}, function (_ref10) {
  var use = _ref10.use,
      active = _ref10.active;
  return handleContainedStyles(use, active);
});

exports.default = _react2.default.createClass({
  displayName: 'UITab',

  propTypes: {
    active: _react.PropTypes.bool,
    href: _UILink2.default.propTypes.href,
    icon: (0, _iconName.getIconNamePropType)(),
    tabId: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]).isRequired,
    title: _react.PropTypes.node.isRequired,
    tooltip: _react.PropTypes.node,
    tooltipProps: _react.PropTypes.object.isRequired,
    tooltipPlacement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS)
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onClick: _emptyFunction2.default,
      tooltipProps: {}
    };
  },


  mixin: [_reactAddonsPureRenderMixin2.default],

  handleClick: function handleClick(evt) {
    var _props = this.props,
        onClick = _props.onClick,
        tabId = _props.tabId;

    (0, _Functions.callIfPossible)(onClick, (0, _SyntheticEvent2.default)(tabId, evt));
  },
  render: function render() {
    var _props2 = this.props,
        active = _props2.active,
        className = _props2.className,
        icon = _props2.icon,
        __onClick = _props2.onClick,
        title = _props2.title,
        tabId = _props2.tabId,
        tooltip = _props2.tooltip,
        tooltipPlacement = _props2.tooltipPlacement,
        tooltipProps = _props2.tooltipProps,
        rest = _objectWithoutProperties(_props2, ['active', 'className', 'icon', 'onClick', 'title', 'tabId', 'tooltip', 'tooltipPlacement', 'tooltipProps']);

    var renderedTabContents = _react2.default.createElement(
      StyledUITab,
      _extends({}, rest, {
        active: active,
        className: (0, _classNames2.default)(className, 'private-tab', {
          'private-tab--active': active,
          'private-tab--with-icon': icon
        }),
        'data-tab-id': tabId,
        'data-tab-selected': active,
        onClick: this.handleClick
      }),
      icon ? _react2.default.createElement(TabIcon, {
        tabIsActive: active,
        className: 'private-tab__icon',
        name: icon,
        size: 'xxs'
      }) : null,
      title,
      _react2.default.createElement(TabIndicator, { tabIsActive: active, className: 'private-tab__indicator' })
    );

    if (!tooltip) return renderedTabContents;

    return _react2.default.createElement(
      _UITooltip2.default,
      _extends({ placement: tooltipPlacement, title: tooltip }, tooltipProps),
      renderedTabContents
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/nav/UITab.js
// module id = 660
// module chunks = 3 4